document.addEventListener('DOMContentLoaded', function () {

  const dropMenu = document.querySelectorAll('.p-dropMenu');

  if(dropMenu){
	dropMenu.forEach((el) => {
	  const label = el.querySelector('.js-drop-label');
	  const body = el.querySelector('.js-drop-body');	  
	  const dropMenuItems = el.querySelectorAll('.p-dropMenu_item');	  
	  const currentUrl = window.location.href.toLowerCase();
	  dropMenuItems.forEach((item) => {
        item.addEventListener('click', (event) => {
          if (item.getAttribute('data-query')) {
			replaceUrl = currentUrl.replace(window.location.search, '');
            window.location.href = replaceUrl + '?sort_by=' + item.getAttribute('data-query');
          }
        });
      });

	  document.addEventListener('click', (event) => {
		if (body) {
		  if (event.target !== label) {
		  if (body?.classList.contains('is-active')) {
			body.classList.remove('is-active');
			body.style.maxHeight = `0px`;
		  }
		  } else {
		  if (body?.classList.contains('is-active')) {
			body.classList.remove('is-active');
			body.style.maxHeight = `0px`;
		  } else {
			body.classList.add('is-active');
			body.style.maxHeight = `90px`;
		  }
		  }
		}
	  });
      
      dropMenuItems.forEach((item) => {
		// コレクションのカレント表示
        const itemText = item.textContent.trim().toLowerCase();
        if (currentUrl.includes(itemText)) {          
          label.textContent = itemText.toUpperCase();
        }
		// 絞り込みのカレント表示
		const itemQuery = item.getAttribute('data-query');
		if(itemQuery){
			if (currentUrl.includes(itemQuery)) {          
				label.textContent = item.textContent.trim().toUpperCase();			  
				item.remove();				
				// URLにクエリパラメータが存在しないか確認				
			}
		}

		if (item.textContent.trim().toUpperCase() === label.textContent) {			
			setTimeout(() => {
				if (window.location.pathname === '/collections/all' && item.textContent.trim().toUpperCase() === 'ALL') {
					item.remove();
				}
				if (window.location.pathname !== '/collections/all' && item.textContent.trim().toUpperCase() === label.textContent) {
					item.remove();	
				}
			}, 1000);
		}
      });
	  	if (!window.location.search) {					
			const latest = document.querySelector('.p-dropMenu_item.latest');
			if(latest){
				latest.remove();
			}
		}

	});
  }
});